import { ExternalLink } from "lucide-react";
import { DEXSCREENER_URL } from "@/components/ContractAddress";

const EMBED_URL =
  "https://dexscreener.com/solana/j15hmrrrtsibcypir2qk5cjzkwddjapj3ku8cnxbvq5k?embed=1&theme=dark&trades=0&info=0";

export default function ChartEmbed() {
  return (
    <section
      id="chart"
      data-testid="chart-section"
      className="relative py-24 sm:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-10">
          <div>
            <div className="font-mono text-xs tracking-[0.32em] text-[#00F0FF] mb-5">
              // LIVE · CHART
            </div>
            <h2 className="font-heading text-4xl sm:text-5xl font-black tracking-tighter leading-[1] text-white">
              $LA28 / SOL <span className="text-[#FFD700] glow-gold">live.</span>
            </h2>
          </div>
          <a
            data-testid="chart-open-dexscreener"
            href={DEXSCREENER_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-neon !py-3 !px-5 text-[10px] self-start"
          >
            OPEN DEXSCREENER <ExternalLink className="w-3.5 h-3.5" />
          </a>
        </div>

        <div
          data-testid="dexscreener-embed"
          className="card-neon overflow-hidden"
          style={{ padding: 0 }}
        >
          <div className="relative w-full" style={{ paddingBottom: "62%" }}>
            <iframe
              title="$LA28 / SOL — DexScreener"
              src={EMBED_URL}
              className="absolute inset-0 w-full h-full"
              style={{ border: 0 }}
              loading="lazy"
              allow="clipboard-write"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
